import { render } from "./VueCroppieCompat.vue?vue&type=template&id=7947b8d4"
import script from "./VueCroppieCompat.vue?vue&type=script&lang=js"
export * from "./VueCroppieCompat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__